import React, { useState, useEffect } from 'react';
import { TaskStatus } from '../types';

interface ProcessingScreenProps {
  isProcessing: boolean;
  taskId: string | null;
  type?: string;
  taskStatus: TaskStatus | null;
  lengthOfRecording?: number | undefined;
}

const ProcessingScreen: React.FC<ProcessingScreenProps> = ({
  isProcessing,
  taskId,
  type = 'Audio',
  taskStatus,
  lengthOfRecording
}) => {
  const [frame, setFrame] = useState(1);

  useEffect(() => {
    if (!isProcessing) return;
    const interval = setInterval(() => {
      setFrame(prev => (prev === 8 ? 1 : prev + 1));
    }, 160);
    return () => clearInterval(interval);
  }, [isProcessing]);

  if (!isProcessing) return null;

  const getEstimatedProcessingTime = () => {
    if (!lengthOfRecording) return null;
    const processingMinutes = Math.ceil(lengthOfRecording / 5 / 60);
    return processingMinutes === 1 ? '1 minuut' : `${processingMinutes} minuten`;
  };

  const estimatedTime = getEstimatedProcessingTime();
  const rotation = (frame - 1) * 45;

  return (
    <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
      <section className="flex-1 lg:basis-[55%] space-y-6">
        <div className="inline-flex items-center gap-3">
          <span className="badge-context">Gespreksverwerking</span>
          <div className="w-7 h-7 flex items-center justify-center">
            <svg
              width="29"
              height="29"
              viewBox="0 0 29 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ transform: `rotate(${rotation}deg)`, transition: 'transform 160ms linear' }}
            >
              <circle cx="14.5" cy="14.5" r="12" stroke="#2380AC" strokeWidth="4" strokeLinecap="round" strokeDasharray="25 50" />
            </svg>
          </div>
        </div>

        <div>
          <h2 className="text-3xl font-semibold text-brand-red">
            Het gesprek wordt verwerkt.
          </h2>
          <p className="text-xl text-brand-blauw leading-relaxed mt-2">
            {estimatedTime
              ? `Dit kan even duren, we verwachten ongeveer ${estimatedTime}.`
              : 'Dit kan even duren, maar niet langer dan een minuut.'}
          </p>
        </div>
      </section>

      <figure className="hidden lg:flex flex-1 lg:basis-[45%] items-center justify-end" aria-hidden="true">
        <img
          src={`${process.env.PUBLIC_URL}/assets/man-achter-bureau-met-client.svg`}
          alt=""
          className="max-h-[280px] w-auto"
          loading="lazy"
        />
      </figure>
    </div>
  );
};

export default ProcessingScreen;
